import { loadable } from 'nordic/lazy';
import compose from '../../../../lib/compose';
import connect from '../../../../store/connect';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import * as actions from '../../../../actions';

const OtherSellersComponent = loadable(() => import('../../../../components/other-sellers'));

const OtherSellers = featureFlag => {
  const AVAILABLE_QUANTITY = 'available_quantity';
  const BULK_SALE_QUANTITY = 'bulk_sale_quantity';

  const mapStateToProps = (
    {
      components: {
        [featureFlag]: other_sellers,
        [AVAILABLE_QUANTITY]: availableQuantity,
        [BULK_SALE_QUANTITY]: bulkSaleQuantity,
      },
      parentUrl,
    },
    ownProps,
  ) => {
    let selectedQuantity;
    if (bulkSaleQuantity?.state === 'VISIBLE' && Number.isInteger(bulkSaleQuantity.selected)) {
      selectedQuantity = bulkSaleQuantity.selected;
    } else {
      selectedQuantity =
        availableQuantity?.state !== 'HIDDEN'
          ? availableQuantity.picker?.selected ||
            (availableQuantity.quantity_selector && availableQuantity.quantity_selector.minimum_quantity)
          : 1;
    }

    return {
      ...ownProps,
      ...other_sellers,
      parentUrl,
      selectedQuantity,
    };
  };

  const mapDispatchToProps = dispatch => ({
    showAddToCartModal: ({ itemId, labelText }) => {
      dispatch(actions.showAddToCartModal({ itemId, labelText }));
    },
    onFetchDeferredComponent: component => dispatch(actions.fetchDeferredComponent(component)),
  });

  const enhance = compose(
    withFeatureFlag(featureFlag),
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
  );

  return enhance(OtherSellersComponent);
};

export default OtherSellers;
